// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const edgeRetirementResponseSchema = z.object({
  "retirement": z.object({
    "edge_id": z.string(),
    "tenant_id": z.string().uuid(),
    "state": z.enum(["pending", "retired"]),
    "reason": z.string(),
    "requested_by": z.string().uuid(),
    "requested_at": z.string().datetime({ offset: true }),
    "route_origins": z.array(z.string()),
    "evidence_status": z.enum(["unknown"]),
    "software_removal": z.enum(["unverified"]),
    "containment_observed_at": z.string().datetime({ offset: true }).optional(),
    "route_confirmed_at": z.string().datetime({ offset: true }).optional(),
    "retired_at": z.string().datetime({ offset: true }).optional(),
    "route_reference": z.string().optional()
  }).nullable()
});
